import { URLS } from '../../../models/url/constants';

export type AwardsImageProps = {
  alt: string;
  imageSrc: string;
};

const AWARDS: { blurb: string; images: AwardsImageProps[] } = {
  blurb: 'We are multi-award winners!',
  images: [
    {
      alt: 'Finder Award',
      imageSrc: URLS.FILES.AWARDS_IMAGES.FINDER,
    },
    {
      alt: 'Finder Award Extras Cover Winner',
      imageSrc: URLS.FILES.AWARDS_IMAGES.FINDER_EXTRAS_WINNER,
    },
    {
      alt: 'WeMoney Award',
      imageSrc: URLS.FILES.AWARDS_IMAGES.WE_MONEY,
    },
  ],
};

export default AWARDS;
